<template>
  <div>
    <div v-if="questionTitle" class="list-title-s" v-html="questionTitle" />
    <div
      v-if="questionText"
      class="mt-4 overflow-hidden transition-all duration-200"
      :class="minimizeQuestion ? ' max-h-20' : 'max-h-full'"
      v-html="questionText"
    />

    <CommonExtender
      v-if="minimizeQuestion"
      :text="$t('ViewFullQuestion')"
      @toggle="showQuestion"
    />

    <div v-if="answerText" class="list-title-s mt-8">
      <template v-if="answerDate">
        {{ $t('AnswerFrom', { date: answerDateFormatted }) }}
      </template>
      <template v-else>
        {{ $t('Answer') }}
      </template>
    </div>
    <div v-if="answerTitle" class="list-title-s mt-2">
      {{ answerTitle }}
    </div>
    <div class="mt-4 mb-8" v-html="answerText" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  questionTitle: {
    type: String,
  },
  questionText: {
    type: String,
  },
  answerTitle: {
    type: String,
  },
  answerText: {
    type: String,
  },
  answerDate: {
    type: Date,
  },
})
const minimizeQuestion = ref(true)
const showQuestion = () => {
  minimizeQuestion.value = false
}
const config = useRuntimeConfig()
const answerDateFormatted = computed(() => {
  if (!props.answerDate) return

  return props.answerDate.toLocaleDateString(config.public.site.localeCode, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
})
</script>
